import React from "react";
import {useNavigate} from "react-router";


export default function withNavigate(Component: React.ComponentType<any>) {
    return (props: any) => {
        const navigate = useNavigate();
        return <Component navigate={navigate} {...props} />;
    };
};